import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, setAuthToken } from "@/lib/api";
import AnimatedLogo from "@/components/site/AnimatedLogo";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    async function submit(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            const { data } = await api.post("/admin/login", { email, password });
            setAuthToken(data.token);
            toast.success("Welcome back.");
            nav("/admin", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="min-h-screen bg-[#F9F8F6]" data-testid="admin-login-page">
            <div className="container-atm flex min-h-screen items-center justify-center py-16">
                <div className="card-3d w-full max-w-md p-8 md:p-10">
                    <AnimatedLogo size="h-12" to="/" withWordmark />
                    <h1 className="mt-8 text-3xl font-semibold">Admin sign in</h1>
                    <p className="mt-2 text-sm text-[#475569]">
                        Manage bookings, payments, vendors, and contact messages.
                    </p>

                    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="mt-2 h-12 rounded-xl"
                                data-testid="admin-email"
                            />
                        </div>
                        <div>
                            <Label htmlFor="password">Password</Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="mt-2 h-12 rounded-xl"
                                data-testid="admin-password"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={submitting}
                            className="btn-primary w-full !py-4"
                            data-testid="admin-login-btn"
                        >
                            {submitting ? (
                                <Loader2 className="animate-spin" size={18} />
                            ) : (
                                "Sign in"
                            )}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}
